import { API_URL } from '../constants/index'
import { getRequest, postRequest, getcontractIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy, date, status) {
  const url = new URL(`${API_URL}deficiency/get-list`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  const contractID = getcontractIdNumber()

  if (contractID !== 0) {
    searchParams.append('contractID', contractID)
  }

  if (size !== null && size !== undefined) {
    searchParams.append('size', parseInt(size, 10) || 15)
  }

  if (index !== null && index !== undefined) {
    searchParams.append('index', parseInt(index, 10) || 0)
  }

  if (searchTerm !== null && searchTerm !== undefined) {
    searchParams.append('searchTerm', searchTerm)
  }

  if (orderBy !== null && orderBy !== undefined) {
    searchParams.append('orderBy', orderBy)
  }

  if (date !== null && date !== undefined) {
    searchParams.append('date', date)
  }

  if (status !== null && status !== undefined) {
    searchParams.append('status', status)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()
  console.log('list deficiencies url', newUrl)
  return getRequest(newUrl)
}

export async function find(id) {
  return getRequest(`deficiency/edit/${id}`)
}

export async function save(values) {
  return postRequest(`deficiency/save`, values)
}

export function remove(values) {
  return postRequest(`deficiency/delete`, values)
}

export const findStatusName = number => {
  if (number === null || number === undefined) return '-'
  switch (number.toString()) {
    case '1':
      return 'deficiency.status.open'
    case '2':
      return 'deficiency.status.completed'
    default:
      return '-'
  }
}
